import React from 'react';
import {TableCell} from 'material-ui/Table';
import {Checkbox} from 'material-ui';
import {
    canAssignPermissionsToRole
} from '../../../components/permissions/permissions';

const TableRolesPermissionsCheckboxes = ({role, perm, rolesPermissions, classes, changeRolePermission, roles}) => {

    const isChecked = rolesPermissions[role.id] != null && rolesPermissions[role.id][perm.id] === true;

    const activeCheckbox = () => (
        <Checkbox
            checked={isChecked}
            onChange={(ev, checked) => changeRolePermission(role.id, perm.id, checked)}
            name={'perm[' + role.id + '][' + perm.id + ']'}
        />
    )

    const disabledCheckbox = () => (
        <Checkbox
            checked={isChecked}
            name={'perm[' + role.id + '][' + perm.id + ']'}
            className={classes.disabledCheckboxes}
        />
    )

    const EnabledOrDisabledCheckboxes = canAssignPermissionsToRole(activeCheckbox, disabledCheckbox);

    return (
        <TableCell key={role.id} className={classes.tableCellCenter}>
            <EnabledOrDisabledCheckboxes />
        </TableCell>
    )
}

export default TableRolesPermissionsCheckboxes;


// WEBPACK FOOTER //
// ./src/containers/roles/forms/TableRolesPermissionsCheckboxes.jsx